<template>
  <ContentWrap>
    <el-alert type="info" :closable="false" show-icon class="mb-12px" title="本所提成：规则须绑定本所律师；按收款/应收生成明细。≠ 平台分账 W6。" />
    <el-tabs v-model="tab">
      <el-tab-pane label="规则" name="rule" />
      <el-tab-pane label="明细" name="entry" />
    </el-tabs>
    <template v-if="tab === 'rule'">
      <el-form :inline="true" class="mb-12px">
        <el-form-item><el-button type="success" @click="openRule">新建规则</el-button></el-form-item>
        <el-form-item><el-button type="primary" @click="loadRules">刷新</el-button></el-form-item>
      </el-form>
      <el-table v-loading="ruleLoading" :data="rules" border>
        <el-table-column prop="id" label="编号" width="70" />
        <el-table-column prop="name" label="名称" min-width="120" />
        <el-table-column prop="baseType" label="基数" width="100" />
        <el-table-column prop="rate" label="费率" width="90" />
        <el-table-column prop="lawyerName" label="律师" width="100" />
        <el-table-column prop="enabled" label="启用" width="70">
          <template #default="{ row }">{{ row.enabled ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template #default="{ row }">
            <el-button link type="danger" @click="delRule(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-model:page="ruleQuery.pageNo" v-model:limit="ruleQuery.pageSize" :total="ruleTotal" @pagination="loadRules" />
    </template>
    <template v-else>
      <el-form :inline="true" class="mb-12px">
        <el-form-item><el-button type="success" @click="openGen">生成明细</el-button></el-form-item>
        <el-form-item><el-button type="primary" @click="loadEntries">刷新</el-button></el-form-item>
      </el-form>
      <el-table v-loading="entryLoading" :data="entries" border>
        <el-table-column prop="id" label="编号" width="70" />
        <el-table-column prop="ruleName" label="规则" min-width="100" />
        <el-table-column prop="firmCaseNo" label="案号" min-width="110" />
        <el-table-column prop="lawyerName" label="律师" width="90" />
        <el-table-column prop="sourceType" label="来源" width="90" />
        <el-table-column prop="sourceId" label="来源ID" width="90" />
        <el-table-column prop="amount" label="提成" width="100" />
        <el-table-column prop="status" label="状态" width="90" />
        <el-table-column label="操作" width="80">
          <template #default="{ row }">
            <el-button v-if="row.status === 'CONFIRMED'" link type="danger" @click="voidEntry(row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-model:page="entryQuery.pageNo" v-model:limit="entryQuery.pageSize" :total="entryTotal" @pagination="loadEntries" />
    </template>

    <Dialog v-model="ruleVisible" title="新建提成规则" width="480px">
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="ruleRules" label-width="90px">
        <el-form-item label="名称" prop="name"><el-input v-model="ruleForm.name" /></el-form-item>
        <el-form-item label="基数" prop="baseType">
          <el-select v-model="ruleForm.baseType" class="!w-100%">
            <el-option label="收款 RECEIPT" value="RECEIPT" />
            <el-option label="应收 REVENUE" value="REVENUE" />
          </el-select>
        </el-form-item>
        <el-form-item label="费率" prop="rate"><el-input-number v-model="ruleForm.rate" :min="0.001" :max="1" :step="0.01" :precision="3" class="!w-100%" /></el-form-item>
        <el-form-item label="律师" prop="lawyerId">
          <el-select v-model="ruleForm.lawyerId" filterable class="!w-100%">
            <el-option v-for="l in lawyers" :key="l.id" :label="`${l.name || '律师'}（#${l.id}）`" :value="l.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="ruleVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitRule">保存</el-button>
      </template>
    </Dialog>

    <Dialog v-model="genVisible" title="生成提成明细" width="480px">
      <el-form ref="genFormRef" :model="genForm" :rules="genRules" label-width="100px">
        <el-form-item label="规则" prop="ruleId">
          <el-select v-model="genForm.ruleId" filterable class="!w-100%">
            <el-option v-for="r in rules" :key="r.id" :label="`${r.name}（${r.baseType}）`" :value="r.id!" />
          </el-select>
        </el-form-item>
        <el-form-item label="来源类型" prop="sourceType">
          <el-select v-model="genForm.sourceType" class="!w-100%">
            <el-option label="收款" value="RECEIPT" />
            <el-option label="应收" value="REVENUE" />
          </el-select>
        </el-form-item>
        <el-form-item label="来源单据ID" prop="sourceId"><el-input-number v-model="genForm.sourceId" :min="1" class="!w-100%" /></el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="genVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitGen">生成</el-button>
      </template>
    </Dialog>
  </ContentWrap>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import {
  FirmOfficeApi,
  type PracticeCommissionEntryVO,
  type PracticeCommissionRuleVO
} from '@/api/firm/office'
import { FirmPortalApi, type FirmLawyerVO } from '@/api/firm/portal'
defineOptions({ name: 'FirmPracticeCommission' })
const message = useMessage()
const tab = ref<'rule' | 'entry'>('rule')
const ruleLoading = ref(false)
const rules = ref<PracticeCommissionRuleVO[]>([])
const ruleTotal = ref(0)
const ruleQuery = reactive({ pageNo: 1, pageSize: 10 })
const entryLoading = ref(false)
const entries = ref<PracticeCommissionEntryVO[]>([])
const entryTotal = ref(0)
const entryQuery = reactive({ pageNo: 1, pageSize: 10 })
const lawyers = ref<FirmLawyerVO[]>([])
const saving = ref(false)
const ruleVisible = ref(false)
const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive({ name: '', baseType: 'RECEIPT', rate: 0.1, lawyerId: undefined as number | undefined })
const ruleRules: FormRules = {
  name: [{ required: true, message: '必填', trigger: 'blur' }],
  baseType: [{ required: true, message: '必选', trigger: 'change' }],
  rate: [{ required: true, message: '必填', trigger: 'blur' }],
  lawyerId: [{ required: true, message: '须指定本所律师', trigger: 'change' }]
}
const genVisible = ref(false)
const genFormRef = ref<FormInstance>()
const genForm = reactive({ ruleId: undefined as number | undefined, sourceType: 'RECEIPT', sourceId: undefined as number | undefined })
const genRules: FormRules = {
  ruleId: [{ required: true, message: '必选', trigger: 'change' }],
  sourceType: [{ required: true, message: '必选', trigger: 'change' }],
  sourceId: [{ required: true, message: '必填', trigger: 'blur' }]
}
const loadRules = async () => {
  ruleLoading.value = true
  try {
    const data = await FirmOfficeApi.commissionRulePage(ruleQuery)
    rules.value = data?.list || []
    ruleTotal.value = data?.total || 0
  } finally {
    ruleLoading.value = false
  }
}
const loadEntries = async () => {
  entryLoading.value = true
  try {
    const data = await FirmOfficeApi.commissionEntryPage(entryQuery)
    entries.value = data?.list || []
    entryTotal.value = data?.total || 0
  } finally {
    entryLoading.value = false
  }
}
watch(tab, (v) => (v === 'rule' ? loadRules() : loadEntries()))
const openRule = async () => {
  Object.assign(ruleForm, { name: '', baseType: 'RECEIPT', rate: 0.1, lawyerId: undefined })
  ruleVisible.value = true
  lawyers.value = (await FirmPortalApi.lawyerAssignableList()) || []
}
const submitRule = async () => {
  await ruleFormRef.value?.validate()
  if (!ruleForm.lawyerId) return
  saving.value = true
  try {
    await FirmOfficeApi.commissionRuleCreate({
      name: ruleForm.name.trim(),
      baseType: ruleForm.baseType,
      rate: ruleForm.rate,
      lawyerId: ruleForm.lawyerId,
      enabled: true
    })
    message.success('已创建')
    ruleVisible.value = false
    await loadRules()
  } finally {
    saving.value = false
  }
}
const delRule = async (row: PracticeCommissionRuleVO) => {
  if (!row.id) return
  try { await message.confirm('确认删除？') } catch { return }
  await FirmOfficeApi.commissionRuleDelete(row.id)
  message.success('已删除')
  await loadRules()
}
const openGen = async () => {
  Object.assign(genForm, { ruleId: undefined, sourceType: 'RECEIPT', sourceId: undefined })
  genVisible.value = true
  if (!rules.value.length) await loadRules()
}
const submitGen = async () => {
  await genFormRef.value?.validate()
  if (!genForm.ruleId || !genForm.sourceId) return
  saving.value = true
  try {
    await FirmOfficeApi.commissionGenerate({
      ruleId: genForm.ruleId,
      sourceType: genForm.sourceType,
      sourceId: genForm.sourceId
    })
    message.success('已生成')
    genVisible.value = false
    tab.value = 'entry'
    await loadEntries()
  } finally {
    saving.value = false
  }
}
const voidEntry = async (row: PracticeCommissionEntryVO) => {
  if (!row.id) return
  await FirmOfficeApi.commissionEntryVoid(row.id)
  message.success('已作废')
  await loadEntries()
}
onMounted(loadRules)
</script>
